import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

/**
 * Thin wrapper around react-google-recaptcha-v3 that:
 *  - exposes `isReady` (true once the script has loaded and executeRecaptcha is wired),
 *  - exposes `getV3Token(action)` which resolves to a fresh token or throws.
 *
 * The hook itself does not poll — the component is responsible for waiting
 * until `isReady` becomes true before calling getV3Token.
 */
const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const isReady = typeof executeRecaptcha === "function";

  const getV3Token = async (action) => {
    if (!isReady) {
      throw new Error("reCAPTCHA v3 is not ready yet.");
    }
    const token = await executeRecaptcha(action);
    if (!token) {
      throw new Error("Failed to obtain reCAPTCHA v3 token.");
    }
    return token;
  };

  return { getV3Token, isReady };
};

export default useRecaptcha;
